import { render, staticRenderFns } from "./LoginBapi.vue?vue&type=template&id=03bc7244&scoped=true&"
import script from "./LoginBapi.vue?vue&type=script&lang=js&"
export * from "./LoginBapi.vue?vue&type=script&lang=js&"
import style0 from "./LoginBapi.vue?vue&type=style&index=0&id=03bc7244&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bc7244",
  null
  
)

export default component.exports